import { Box, IconButtonLink } from "@seneca/senekit";

import { Link } from "common/types/routing";

type Props = {
  quitLink: Link;
};

export default function SidebarHeaderExitButton({ quitLink }: Props) {
  return (
    <Box dataTest="ExitButtonIcon">
      <IconButtonLink
        iconName="house"
        blend
        to={quitLink}
        accessibilityLabel="Home"
      />
    </Box>
  );
}
